export default __webpack_public_path__ + "static/media/13-cn.7cf9bcd2.webp";